<template>
	<div class="d-flex fill-height">
		<div class="ma-auto">
			<!-- <img
				class="logo-preloader"
				src="/logo.svg"
				alt="logo-preloader"
				style="width: 200px;"
			> -->
		</div>
	</div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'

import { useUserStore } from '@/stores/userStore'

import { ROUTER_NAMES } from '@/config/router/routerNamesConfig.js'

const router = useRouter()

const userStore = useUserStore()

onMounted(() => {
	if (userStore.selectedCompanyId && userStore.availableCompanies.length) {
		router.push({ name: ROUTER_NAMES.CROPS_STRUCTURES.DASHBOARD, params: { companyId: userStore.selectedCompanyId } })
	}
})
</script>

<style>
</style>
